import { SubscriptionDetailsResponse } from "@9amhealth/openapi";
import FunnelKey from "src/constants/funnelKey";
import { SAML_FUNNEL_KEY_SESSION_STORAGE_KEY } from "src/lib/useSamlAuth";

export function determineFunnelKey(params: {
  draftSubscription?: SubscriptionDetailsResponse;
  lastSignupFunnel?: string;
}): FunnelKey {
  const samlFunnel = sessionStorage.getItem(
    SAML_FUNNEL_KEY_SESSION_STORAGE_KEY
  );
  if (samlFunnel) {
    return samlFunnel as FunnelKey;
  }

  if (params.draftSubscription?.funnel) {
    return params.draftSubscription.funnel as FunnelKey;
  }

  if (params.lastSignupFunnel) {
    return params.lastSignupFunnel as FunnelKey;
  }

  return FunnelKey.universal;
}
